import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Observable } from 'rxjs';
import { AccountConfiguration } from '../../../dashboard/models/account-configuration.model';
import { AccountConfigurationService } from '../../../dashboard/services/account-configuration.service';
import { PromotionCouponsService } from '../../../promotion-coupons/services/promotion-coupons.service';
import { AuthStoreService } from '../../../shared/services/auth/auth-store.service';
import { AppConfig } from '../../services/app-config.service';
import { HandsetService } from '../../services/handset.service';
import { map } from 'rxjs/operators';
import { Crisp } from 'crisp-sdk-web';
import { HttpClient } from '@angular/common/http';
import { Subpage } from '../../../shared/models/subpage.model';
import {
  ContentDataStoreService,
  INotificationsCountInfo,
} from '../../../liabilities/services/content-data-store.service';

@Component({
standalone: false,
  selector: 'app-sidenav',
  styleUrls: ['./sidenav.component.scss'],
  templateUrl: './sidenav.component.html',
})
export class SidenavComponent implements OnInit {
  @Input() public drawer: MatSidenav;

  public menuToggle: boolean;
  public accountConfiguration: Observable<AccountConfiguration>;
  public notificationsCountInfo: Observable<INotificationsCountInfo>;
  public isAdmin$: Observable<boolean>;
  public sideNavItems: BehaviorSubject<Subpage[]>;

  @Output()
  public clickEvent = new EventEmitter<void>();

  constructor(
    public authStoreService: AuthStoreService,
    public handsetService: HandsetService,
    public appConfig: AppConfig,
    public promotionCouponsService: PromotionCouponsService,
    private accountConfigurationService: AccountConfigurationService,
    public contentDataStoreService: ContentDataStoreService,
    private _http: HttpClient,
  ) {
    this.accountConfiguration = accountConfigurationService.accountConfiguration$;
    this.isAdmin$ = this.authStoreService.state$.pipe(map(() => this.authStoreService.isAdmin));
  }

  public ngOnInit(): void {
    this.notificationsCountInfo = this.contentDataStoreService.state$;
    this.sideNavItems = new BehaviorSubject<Subpage[]>(this.getSideNavItems());
  }

  public getSideNavItems(): Subpage[] {
    return [
      {
        id: 1,
        showItem: false,
        link: '/dashboard',
        icon: 'speed',
        iconStyle: '',
        label: `Konfiguracja: ${this.accountConfiguration}%`,
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },
      {
        id: 2,
        showItem: false,
        link: this.appConfig.config.visaContest?.enabled ? '/rachunkisieplaca' : '/promotion-coupons',
        icon: this.appConfig.config.visaContest?.enabled ? 'emoji_events' : 'redeem',
        iconStyle: 'referral-icon',
        label: `{{ promotionCouponsService.statusMessage$ | async }}`,
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },

      {
        id: 3,
        showItem: true,
        link: '/dashboard',
        icon: 'dashboard',
        iconStyle: '',
        label: 'Pulpit',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: true,
      },
      {
        id: 4,
        showItem: true,
        link: '/deferred-payments',
        icon: 'expenses',
        iconStyle: '',
        label: 'Odroczone wydatki',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: true,
        showNotificationDeferments: true,
      },
      {
        id: 5,
        showItem: true,
        link: '/liabilities/all',
        icon: 'alarm',
        iconStyle: '',
        label: 'Twoje wydatki',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },
      {
        id: 6,
        showItem: true,
        link: '/liabilities/add',
        icon: 'library_add',
        iconStyle: '',
        label: 'Dodaj nowy',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: true,
      },
      {
        id: 7,
        showItem: true,
        link: '/billers',
        icon: 'suppliers',
        iconStyle: '',
        label: 'Dostawcy',
        showNotification: true,
        showOffersBadge: false,
        showDividerAfter: true,
      },
      {
        id: 8,
        showItem: false,
        link: '/liabilities/urgent',
        icon: 'expenses',
        iconStyle: '',
        label: 'Bieżące opłaty',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },


      {
        id: 9,
        showItem: false,
        link: '/creditCards',
        icon: 'store',
        iconStyle: '',
        label: 'Karty płatnicze',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },
      {
        id: 10,
        showItem: false,
        link: '/paymentHistory',
        icon: 'history',
        iconStyle: '',
        label: 'Historia płatności',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },
      {
        id: 11,
        showItem: false,
        link: '/charts',
        icon: 'assessment',
        iconStyle: '',
        label: 'Statystyki',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },
      {
        id: 12,
        showItem: this.appConfig.config.features.offersEnabled,
        link: '/offers',
        icon: 'local_offer',
        iconStyle: '',
        label: 'Oferty',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },
      {
        id: 13,
        showItem: this.appConfig.config.couponsPage.enabled,
        link: '/promotion-coupons',
        icon: 'redeem',
        iconStyle: 'redeem',
        label: 'Kupony promocyjne',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },
      {
        id: 14,
        showItem: this.appConfig.config.visaContest.enabled,
        link: '/rachunkisieplaca',
        icon: 'emoji_events',
        iconStyle: 'emoji_events',
        label: 'Konkurs z VISA',
        showNotification: false,
        showOffersBadge: false,
        showDividerAfter: false,
      },
    ];
  }

  public openIntercom(): void {
    if (typeof Intercom !== 'undefined') {
      Intercom('showNewMessage');
    }
  }

  public close() {
    this.clickEvent.emit();

  }

  public openCrisp(): void {
    if (window['$crisp']) {
      Crisp.chat.open();
    }
  }
}
